var map = {
	"./decidim/budgets/decidim_budgets.svg": "./vendor/ruby/3.3.0/bundler/gems/decidim-a9afb2c85a88/decidim-budgets/app/packs/images/decidim/budgets/decidim_budgets.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./vendor/ruby/3.3.0/bundler/gems/decidim-a9afb2c85a88/decidim-budgets/app/packs/images sync recursive ^\\.\\/.*$";